var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59,
    height: 66.948,
    viewBox: "0 0 59 66.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_274",
    x: 0,
    y: 43.948,
    width: 59,
    height: 23,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7451",
    "data-name": "Group 7451",
    transform: "translate(9.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-location-1055261",
    transform: "translate(2.166 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M216.869,72.8A18.069,18.069,0,0,0,198.8,90.87a13.952,13.952,0,0,0,2.677,8.7l15.392,22.754L232.261,99.57a13.949,13.949,0,0,0,2.677-8.7A18.069,18.069,0,0,0,216.869,72.8Zm0,9.369a8.031,8.031,0,1,1-8.031,8.031A8.031,8.031,0,0,1,216.869,82.17Z",
    transform: "translate(-198.8 -72.801)",
    fill: "#e37939"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.08, 0)",
    filter: "url(#Ellipse_274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_274-2",
    "data-name": "Ellipse 274",
    transform: "translate(9 49.95)",
    fill: "#818181",
    stroke: "#818181",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 2.5,
    rx: 20.5,
    ry: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 2.5,
    rx: 20,
    ry: 2,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptin);
export default __webpack_public_path__ + "static/media/optin.55ddbf04c42389cea5b25d72673bc1c3.svg";
export { ForwardRef as ReactComponent };